module.exports = __webpack_public_path__ + "static/media/ic_update_db.7322b671.svg";